import React, { useMemo, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ProductConfigurator from '../ProductConfigurator';
import { configurationRows, hasProductConfiguration } from '../../lib/product-configurations';
import { publicJSON } from '../../lib/public-catalogue-cache';
import { modelSlug } from '../../lib/catalogue-paths';

export const FamilyModelConfigurator = ({variants, collection, family}) => {
  const models = useMemo(() => [...new Map(variants.filter(v => v.product_id && v.base_code && v.catalogue_role !== 'component' && hasProductConfiguration(v)).map(v => [v.base_code,v])).values()], [variants]);
  const [chosen, setChosen] = useState('');
  const selected = models.find(v => v.base_code === chosen) || models[0];
  const [state, setState] = useState({});
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    if (!selected) return;
    let live = true;
    setState({loading:true});
    publicJSON(`/product-catalog/${encodeURIComponent(selected.product_id)}`).then(product => {
      if (live) setState({product});
    }).catch(() => { if (live) setState({error:true}); });
    return () => { live=false; };
  }, [selected?.product_id, attempt]);
  if (!selected) return null;
  return <section className="max-w-[1120px] mx-auto px-4 sm:px-6 py-8 sm:py-10 border-t border-neutral-200" data-testid="family-model-configurator">
    <div className="flex flex-wrap items-end justify-between gap-3 mb-5">
      <div className="min-w-0 w-full sm:max-w-xs">
        <label htmlFor="family-config-model" className="block text-xs text-neutral-600 mb-1.5">Model</label>
        <select id="family-config-model" data-testid="family-config-model" value={selected.base_code} onChange={e => setChosen(e.target.value)} className="w-full min-w-0 h-10 border border-neutral-300 rounded px-2 text-xs bg-white">
          {models.map((m,i) => <option data-testid={`family-config-model-option-${i}`} key={m.base_code} value={m.base_code}>{m.base_code} · {configurationRows(m).length} listed configurations</option>)}
        </select>
      </div>
      <Link data-testid="family-config-model-detail" to={`/${collection}/${family}/${modelSlug(selected.base_code)}`} className="text-xs underline underline-offset-4">Model details ↗</Link>
    </div>
    {state.loading ? <p role="status" data-testid="family-config-loading">Loading configuration…</p> : state.error ? <div role="alert" data-testid="family-config-error"><p>Configuration could not be loaded.</p><button data-testid="family-config-retry" className="underline mt-3" onClick={() => setAttempt(v=>v+1)}>Try again</button></div> : state.product && <ProductConfigurator key={state.product.product_id} product={state.product} />}
  </section>;
};